import { type TeamPledgeDistributionDTO, useAppTheme } from '@capsicum/common';
import { rgba } from 'polished';

import { getWCPledgeTeamFlagUrl } from '../util';

export const useWCPledgeLeaderboardCard = (item: TeamPledgeDistributionDTO, rank: number) => {
	const theme = useAppTheme();
	const getCardColor = (rank: number): { background: string; border: string } | null => {
		switch (rank) {
			case 1:
				return {
					background: rgba(theme.theme.colors.decorativeGold, 0.05),
					border: theme.theme.colors.decorativeGold
				};
			case 2:
				return {
					background: rgba(theme.theme.colors.decorativeSilver, 0.05),
					border: theme.theme.colors.decorativeSilver
				};
			case 3:
				return {
					background: rgba(theme.theme.colors.decorativeBronze, 0.05),
					border: theme.theme.colors.decorativeBronze
				};
			default:
				return null;
		}
	};

	const cardColor = getCardColor(rank);
	const isTopThree = rank <= 3;
	const isFirstPlace = rank === 1;
	const flagUrl = getWCPledgeTeamFlagUrl(item.team);
	const percentage = parseFloat(item.pledgedPercentage);

	return {
		cardColor,
		flagUrl,
		isFirstPlace,
		isTopThree,
		percentage
	};
};
